import { Dismiss24Regular } from "@fluentui/react-icons";
import styles from "./DescriptionModal.module.css";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    description: string;
    id_dnp: string;
}

export const DescriptionModal = ({ isOpen, onClose, title, description, id_dnp }: Props) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={handleOverlayClick}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2 className={styles.title}>{title}</h2>
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                        aria-label="Cerrar"
                    >
                        <Dismiss24Regular />
                    </button>
                </div>
                <div className={styles.body}>
                    <p className={styles.description}>{description}</p>
                    {/* <p className={styles.idDnp}>ID DNP: {id_dnp}</p> */}
                </div>
            </div>
        </div>
    );
};
